import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { communication } from "../../services/communication";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import { faCircleLeft } from "@fortawesome/free-solid-svg-icons";

const AddComplaint = () => {
  const router = useNavigate();
  

 
  const [loader, setLoader] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const state = watch("state");

  const onSubmit = async (data) => {
    console.log("data : ", data);
    try {
      setLoader(true);
      const responseFromServer = await communication.createAnnouncement(data); // Directly sending `data` as JSON
      if (responseFromServer?.data?.status === "SUCCESS") {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "success" });
        router("/main-panel/complaint")
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        router("/login");
      } else {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
    } catch (error) {
      setLoader(false);
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
    }
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="add_update_form_wrapper">
          <div className="add_update_form_main position-relative">
            <div
              title="Go back"
              onClick={() => router("/main-panel/complaint")}
              className="User_back_icon"
            >
              <FontAwesomeIcon icon={faCircleLeft} />
            </div>

            <div className="add_update_form_section">
              <div className="add_update_heading">
                <h4>Add  Announcement</h4>
              </div>

              <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                <div className="input_col">
                  <div className="label_div">
                    <label>Title</label>
                  </div>
                  <div className="input_div">
                    <input
                      {...register("title", {
                        required: "title is required",
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "title should contain only letters",
                        },
                      })}
                      placeholder={"Enter title"}
                      type="text"
                      className="form-control input login_input"
                    />
                    <div className="error-message">
                      {errors?.title && (
                        <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                          {errors?.title.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                <div className="input_col">
                  <div className="label_div">
                    <label>Description</label>
                  </div>
                  <div className="input_div">
                    <textarea
                      {...register("description", {
                        required: "Description is required",
                        // pattern: {
                        //   // value: /^[A-Za-z\s]+$/,
                        //   message: "Description should contain only letters",
                        // },
                      })}
                      rows={3}
                      placeholder={"Enter Description"}
                      type="text"
                      className="form-control input login_input"
                    />
                    <div className="error-message">
                      {errors?.description && (
                        <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                          {errors?.description.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                <div className="input_col">
                  <div className="label_div">
                    <label>Created By</label>
                  </div>
                  <div className="input_div">
                    <input
                      {...register("createdBy", {
                        required: "Created By is required",
                        // pattern: {
                        //   value: /^[A-Za-z\s]+$/,
                        //   message: "title should contain only letters",
                        // },
                      })}
                      placeholder={"Enter Created By Name"}
                      type="text"
                      className="form-control input login_input"
                    />
                    <div className="error-message">
                      {errors?.createdBy && (
                        <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                          {errors?.createdBy.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                <div className="input_col">
                  <div className="label_div">
                    <label>Position</label>
                  </div>
                  <div className="input_div">
                    <input
                      {...register("position", {
                        required: "Position is required",
                        // pattern: {
                        //   value: /^[A-Za-z\s]+$/,
                        //   message: "title should contain only letters",
                        // },
                      })}
                      placeholder={"Enter Position"}
                      type="text"
                      className="form-control input login_input"
                    />
                    <div className="error-message">
                      {errors?.position && (
                        <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                          {errors?.position.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

             

              {/* submit and cancel button for add user page*/}
              <div className="button_wrapper">
                <div className="button_col">
                  <button
                    type="submit"
                    onClick={handleSubmit(onSubmit)}
                    className="btn btn-primary submit_button"
                  >
                    Submit
                  </button>
                </div>
                <div className="button_col">
                  <button
                    onClick={() => router("/main-panel/complaint")}
                    className="btn btn-primary cancel_button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddComplaint;
